import { CareCommentContent } from "../../../../domain/care_comment/CareCommentContent";
import { CareCommentId } from "../../../../domain/care_comment/CareCommentId";
import { CareCommentThreadId } from "../../../../domain/care_comment/CareCommentThreadId";
import { CareCommentTitle } from "../../../../domain/care_comment/CareCommentTitle";
import { CareRecipientId } from "../../../../domain/care_recipient/CareRecipientId";
import { ApiPaths } from "../../../api/ApiPaths";
import { ApiRequest } from "../../../api/ApiRequest";

export type UpsertCareCommentSuccessResponseType = {
    id: string,
    careRecipientId: string,
    title: string,
    content: string,
    createdTime: string,
    // API処理結果判別用：OK->undefined、NG->ErrorResponseType
    error: undefined
}

export type RegisterCareCommentRequestType = {
    careRecipientId: CareRecipientId,
    threadId?: CareCommentThreadId,
    title: CareCommentTitle,
    content: CareCommentContent,
};

export type UpdateCareCommentRequestType = {
    id: CareCommentId,
    title: CareCommentTitle,
    content: CareCommentContent,
};

export async function registerCareComment(
    body: RegisterCareCommentRequestType
): Promise<UpsertCareCommentSuccessResponseType> {
    return await ApiRequest.post(
        ApiPaths.admin.careCommentRegister,
        {},
        convertRegisterBody(body),
        () => {},
        () => {}
    );
}

export async function updateCareComment(
    body: UpdateCareCommentRequestType    
): Promise<UpsertCareCommentSuccessResponseType> {
    return await ApiRequest.post(
        ApiPaths.admin.careCommentUpdate.replace(/\{careCommentId\}/g, body.id.value),
        {},
        convertUpdateBody(body),
        () => {},
        () => {}
    );
}

export async function deleteCareComment(
    careCommentId: CareCommentId
) {
    return await ApiRequest.delete(
        ApiPaths.admin.careCommentDelete,
        {
            care_comment_id: careCommentId.value
        },
        () => {},
        () => {}
    );
}

const convertRegisterBody = (body: RegisterCareCommentRequestType) => {
    return {
        careRecipientId: body.careRecipientId.value,
        threadId: body.threadId?.value ?? null,
        title: body.title.value,
        content: body.content.value
    };
};

const convertUpdateBody = (body: UpdateCareCommentRequestType) => {
    return {
        title: body.title.value,
        content: body.content.value
    };
};